import device from '~/mixins/device.js'

export default {
  mixins: [device],

  props: {
    hasLogo: {
      type: Boolean,
      default: true,
    },

    hasBackground: {
      type: Boolean,
      default: false,
    },

    noTransform: {
      type: Boolean,
      default: false,
    },

    locale: {
      type: String,
    },

    route: {
      type: Object,
    },

    element: {
      type: String,
    },
  },

  data() {
    return {
      url: process.env.BASE_URL,
      loading: true,
      iframeSrc: 'about:blank',
    }
  },

  mounted() {
    this.loadIframe()
  },

  methods: {
    loadIframe() {
      this.iframeSrc = `https://sso.${this.hostname}/signup?variant&${this.logo}&${this.transparent}&embed&locale=${
        this.locale
      }&service=${encodeURIComponent(
        `${this.service}?isEmbed=true&element=${this.element}&url=sso.${this.hostname}/signup?variant${this.logo}&embed&locale=${this.locale}&referrer=https://${this.hostname}${this.path}?${this.query}`
      )}`

      this.loading = false
    },
  },

  computed: {
    isHomepage() {
      return Boolean(this.route.name && this.route.name.includes('index'))
    },

    hostname() {
      const urlObject = new URL(this.url)

      return urlObject.hostname
    },

    service() {
      if (this.url === 'https://hotmart.com') {
        return 'https://app.hotmart.com/'
      }

      return 'https://app.buildstaging.com/'
    },

    path() {
      return this.route.path
    },

    logo() {
      return this.hasLogo ? '' : 'nologo'
    },

    transparent() {
      return this.hasBackground ? '' : 'transparent'
    },

    query() {
      return Object.keys(this.route.query)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(this.route.query[key])}`)
        .join('&')
    },
  },
}
